/** The bare host of a document's source URL, for compact provenance display
 * ("blog.example.com" beats the full URL in a badge). Empty on bad input. */
export function sourceHost(sourceUrl) {
  try {
    return new URL(sourceUrl).host;
  } catch {
    return "";
  }
}
